import React from 'react'
import { Modal, Box, Typography } from '@mui/material'
// import { Close } from '@mui/icons-material'
import './Modal.css'
import { border_cross } from '../../assets/icons'

const ModalWrapper = ({
  title,
  open,
  handleClose,
  children,
  width,
  adminAdd,
  confirmDelete,
  subtxt,
  fees,
}) => {
  return (
    <div className="popup-box">
      <Modal
        open={open}
        onClose={handleClose}
        hideBackdrop={true}
        aria-labelledby="basic-popup-title"
        aria-describedby="basic-popup-description"
      >
        <Box
          sx={{
            width: width ? width : 'fit-content',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: fees ? 0 : '24px',
          }}
          className="popup-container"
        >
          {!adminAdd && !confirmDelete && (
            <div className="popup-header">
              <div className="txtdiv">
                <Typography className="popup-title">{title}</Typography>
                <p className="modal-subtxt">{subtxt}</p>
              </div>
              <img
                src={border_cross}
                alt=""
                style={{
                  width: '36px',
                  height: '36px',
                }}
                onClick={handleClose}
              />
              {/* <Close onClick={handleClose} /> */}
            </div>
          )}
          {confirmDelete && (
            <Typography fontSize={'20px'} textAlign={'center'} fontWeight={600}>
              {title}
            </Typography>
          )}

          {children}
        </Box>
      </Modal>
    </div>
  )
}

export default ModalWrapper
